jQuery(document).ready(function ($) { 
  
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '1200',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });
  
});


// vanilla javascript
document.addEventListener("DOMContentLoaded", function () {

  // go to tab content 
  let goToLink = document.querySelectorAll('.go-to');
  let headerHeight = document.querySelector('header.sticky-top').clientHeight;

  goToLink.forEach(el => {
    let goToTab = el.getAttribute('data-target');
    let tabTarget = document.querySelector(goToTab);

    tabTarget.style.scrollMargin = headerHeight + 'px';

    const options = {
      attributes: true
    }
    
    function callback(mutationList, observer) {
      mutationList.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          tabTarget.scrollIntoView();
        }
      })
    }
    
    // go to tab when link is clicked first time
    const observer = new MutationObserver(callback);
    observer.observe(el, options);

    // go to tab when link is clicked afterwards
    el.addEventListener('click',function () {
      tabTarget.scrollIntoView();
    });
    
  });

  let nextTab = document.querySelectorAll('.next-tab');
  let sectionTabs = document.getElementById('section-tabs');
  let tabLink = document.querySelectorAll('#remodeling-pathway li a');
  nextTab.forEach(el => {
    el.addEventListener('click',function (event) {
      event.stopPropagation();
      let tabLinkActive = document.querySelector('#remodeling-pathway li a.active').parentNode;
      let next = tabLinkActive.nextElementSibling;

      if (next) {
        next.children[0].click()  
        sectionTabs.scrollIntoView();
      } else {
        tabLink[0].click(); // Click the first element since this is the last one
        sectionTabs.scrollIntoView();
      }
    });
  });

  // put search on dropdown
  let searchMobile = document.querySelector('.search-wrapper.search-mobile > .inner-search');
  document.querySelector('.search-collapse').appendChild(searchMobile);

  // make the sticky magic happen on the menu
  window.addEventListener('scroll', (e) => {
    let scrolled_val = window.scrollY;

    // wrappers
    let searchDesktop = document.querySelector('.search-wrapper.search-desktop');
    let searchDropdown = document.querySelector('.search-dropdown');
    // targets 
    let searchDesktopInner = document.querySelector('.search-wrapper.search-desktop > .inner-search');
    let searchDropdownInner = document.querySelector('.search-dropdown > .inner-search');
    
    let headerHeight = document.getElementById('navigation').clientHeight;
    if(scrolled_val > headerHeight) {
      document.querySelector('header.sticky-top').classList.add('is-pinned');
      if (searchDesktopInner) {
        searchDropdown.appendChild(searchDesktopInner);
      }
    }
    
    if(scrolled_val == 0) { 
      document.querySelector('header.sticky-top').classList.remove('is-pinned');
      if (searchDropdownInner) {
        searchDesktop.appendChild(searchDropdownInner);
      }
    }
  });


  // Be Inspired Gallery
  let beInspiredGallery = document.getElementById('gallery-filter');
  if (beInspiredGallery) {

    // gallery filter dropdown multiselection
    let dropdown = document.querySelectorAll('#gallery-filter .dropdown-menu');
    dropdown.forEach(el => {
      el.addEventListener('click',function (event) {
        event.stopPropagation();
      });
    });

    // gallery clear all filters
    let clearFilters = document.getElementById('gallery-clear-filters');
    let checkboxFilters = document.querySelectorAll('#gallery-filter .dropdown-menu input[type="checkbox"]');
    clearFilters.addEventListener('click',function () {
      checkboxFilters.forEach(el => {
        el.checked = false;
      });
    });
  }

  // Carousel thumbnails update on click
  let carouselThumbs = document.querySelectorAll('.carousel-thumbnails > div');
  if (carouselThumbs.length) {
    carouselThumbs.forEach(el => {
      el.addEventListener('click', (e) => {
        document.querySelector('.carousel-thumbnails > div.active').classList.remove('active');
        el.classList.add('active');
      });
    });
  }

  // Carousel thumbnails update indicators CSS transition  
  let beInspiredIndicators = document.querySelectorAll('#beInspiredCarousel .carousel-indicators > li');
  beInspiredIndicators.forEach(el => {
    el.addEventListener('transitionend', (e) => {
      if(el.classList.contains('active')) {
        let indicatorDataSlideTo = parseInt(el.getAttribute('data-slide-to'));
        document.querySelector('.carousel-thumbnails > div.active').classList.remove('active');
        document.querySelector('.carousel-thumbnails > div[data-slide-to="' + indicatorDataSlideTo + '"]').classList.add('active')
      }
    });
  });


  // Home Owners Tabs Navigation
  let homeOwnersNav = document.getElementById('nav-homeowner');
  let homeOwnersNavInner = document.getElementById('event-tabs');

  if (homeOwnersNav) {

    function checkTabsWidth() {
      let navWidth = homeOwnersNav.offsetWidth;
      let navChildren = homeOwnersNavInner.children;
      let navInnerWidth = 32; // not 0, but the original spacing of parent element
      for (let i = 0; i < navChildren.length; i++) {
        navInnerWidth += parseInt(navChildren[i].offsetWidth, 10);
      }
  
      if(navWidth <= navInnerWidth){
        homeOwnersNav.classList.add('h-scrolled');
      } else {
        homeOwnersNav.classList.remove('h-scrolled');
      }
      
      // homeowners tabs nav controls
      // scroll to view when item is half hidden
      let hScrolledItems = document.querySelectorAll('.h-scrolled .nav-item');
      if (hScrolledItems.length) {
        hScrolledItems.forEach(el => {
          el.addEventListener('click', (e) => {
            let listWidth = homeOwnersNavInner.offsetWidth;
            let itemLeft = el.offsetLeft;
            let itemWidth = el.offsetWidth;
            let itemRight = itemLeft + itemWidth + 60;
            if (itemRight > listWidth) {
              let difference = itemRight - listWidth;
              homeOwnersNavInner.scroll({
                left: difference,
                behavior: 'smooth'
              });
            } else {
              homeOwnersNavInner.scroll({
                left: 0,
                behavior: 'smooth'
              });
            }
          });  
        });
      }
    }

    checkTabsWidth();
    
    window.addEventListener('resize', (e) => {
      checkTabsWidth();
    });

      
    // homeowners tabs nav controls
    homeOwnersNav.querySelector('.control-left').addEventListener('click', function () {
      homeOwnersNavInner.scrollBy({
        left: -200,
        behavior: 'smooth'
      });
    });
    homeOwnersNav.querySelector('.control-right').addEventListener('click', function () {
      homeOwnersNavInner.scrollBy({
        left: 200,
        behavior: 'smooth'
      });
    });

  }

});